export default __webpack_public_path__ + "static/media/life-ring-solid-white.0b8483e6.svg";